export default __webpack_public_path__ + "static/media/dark-mode.37ab7e2b.svg";